var option_default = {
  "option": "Q1J-N",
  "user_choice": "ihuGI",
  "check": "_0DUBX",
  "image": "om-zI",
  "input": "J8XZM",
  "title": "LeLPk",
  "centered": "MTG0A",
  "with_result": "tYQ-K",
  "list": "beFFv",
  "with_image": "zu22G",
  "progress": "iUlxl",
  "progress_value": "C8zml",
  "label": "zn8Ww",
  "cta": "VSEiO",
  "adornment_icon": "q4bux",
  "remove": "ZGJ9T",
  "removeButton": "M8zmW",
  "removeButtonIcon": "ZpkP7",
  "overlay": "klU9r",
  "shown": "hCGBX",
  "dark": "ZN4wc",
  "spinner": "n692q",
  "spin": "yrljz"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
